t = require('views/internal/teacup-with-helpers')('product_promo_button')
getExperiment = require 'lib/experiments/simple-test'

module.exports = t.renderable ({ upsellEnabled }) ->
  adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')

  t.div '.product-promo-button-overlay', ->

    if !adsLayoutExperimentEnabled
      t.span '.product-promo-button', ->
        if upsellEnabled
          t.format 'get-business-class'
        else
          t.format 'not-available'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/product_promo_button.coffee